import type { MediaFormData } from "../media/media"
import type { BatchEditItem } from "../media/batch/batchEditItem"

export function fromMediaFormData(draft: MediaFormData): BatchEditItem {
  return {
    uuid: draft.uuid,
    filename: draft.filename,
    mediaType: "",
    length: 0,
    previewUrl: null,
    copyright: draft.copyright,
    copyrightUrl: draft.copyrightUrl,
    license: draft.license,
    licenseUrl: draft.licenseUrl,
    sourceUrl: draft.sourceUrl,
    watermark: draft.watermark,
    tags: draft.tags,
    companies: draft.companies,
    gameSeries: draft.gameSeries,
    games: draft.games,
    gameConsoles: draft.gameConsoles
  }
}
